import WSConnectManager from "@/pages/WebSocketConnect.vue";

import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import { sensors } from "@/utils/userInfo.js";

// Dashboard pages
import TemperatureDashboard from "@/pages/Dashboard/TemperatureDashboard2.vue";
import EnergyMeterDashboard from "@/pages/Dashboard/EnergyMeterDashboard.vue";
import WaterMeterDashboard from "@/pages/Dashboard/WaterMeterDashboard.vue";
import SavingsCalculator from "@/pages/Dashboard/SavingsCalculator.vue";
import SchemaPage from "@/pages/Dashboard/SchemaPage.vue";

import Infosite from "@/pages/Dashboard/Infosite.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/Dashboard/Pages/Login.vue"),
  },
  {
    path: "/",
    component: WSConnectManager,
    children: [
      {
        path: "",
        redirect: "/infosite",
      },
      {
        path: "",
        component: DashboardLayout,
        children: [
          {
            path: "infosite",
            name: "Aktuálne dáta",
            components: { default: Infosite },
            meta: { requiresAuth: true },
          },
          {
            path: "TemperatureSensor/:sensorPath",
            name: "Teplotný senzor",
            components: { default: TemperatureDashboard },
            meta: { requiresAuth: true },
          },
          {
            path: "EnergyMeter/:sensorPath",
            name: "Merač energie",
            components: { default: EnergyMeterDashboard },
            meta: { requiresAuth: true },
          },
          {
            path: "WaterMeter/:sensorPath",
            name: "Merač objemu",
            components: { default: WaterMeterDashboard },
            meta: { requiresAuth: true },
          },
          {
            path: "schema",
            name: "Schéma systému",
            components: { default: SchemaPage },
            meta: { requiresAuth: true },
          },
          {
            path: "calculator",
            name: "Kalkulačka úspory",
            components: { default: SavingsCalculator },
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  },
];

export default routes;
